module.exports = __webpack_public_path__ + "static/media/Savvy-Sad-Look.8044fab6.png";